import { FC, CSSProperties } from 'react';
import { Box, ButtonProps, makeStyles } from '@material-ui/core';
import { WbButton } from '../WbButton';

interface Props {
  cancel: ButtonProps;
  apply: ButtonProps;
  containerStyle?: CSSProperties;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      padding: '8px 16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      [theme.breakpoints.down('xs')]: {
        padding: '6px 12px',
      },
    },
    button: {
      flex: 1,
    },
  }),
  { name: 'FilterButtons' },
);

export const FiltersButton: FC<Props> = ({ cancel, apply, containerStyle }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={containerStyle}>
      <WbButton
        className={classes.button}
        variant="outlined"
        color="primary"
        label="Cancel"
        {...cancel}
      />
      <WbButton
        className={classes.button}
        variant="contained"
        color="primary"
        label="Apply"
        {...apply}
      />
    </Box>
  );
};
